import { NzNotificationService } from 'ng-zorro-antd/notification';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiOptions, DefaultParams, ParamsAdapter } from '../kernel';
import { environment } from 'src/environments/environment';

export abstract class ServiceBase {
  public baseRoute = `${environment.settings.api_url}/${environment.settings.api_version}`;
  options: ApiOptions = new ApiOptions();

  protected constructor(protected httpClient: HttpClient, private _notification: NzNotificationService) {}

  protected get<T>(url: string, params: ParamsAdapter = new DefaultParams()): Observable<T> {
    return this.httpClient.get<T>(url, {
      params: params.build() as HttpParams,
      responseType: this.options.responseType as 'json'
    });
  }

  protected post<T>(
    url: string,
    params: ParamsAdapter = new DefaultParams(),
    reCaptchaToken: string = ''
  ): Observable<T> {
    return this.httpClient.post<T>(url, params, {
      responseType: this.options.responseType as 'json',
      headers: {
        reCaptchaToken: reCaptchaToken
      }
    });
  }

  protected patch<T>(url: string, params: ParamsAdapter = new DefaultParams()): Observable<T> {
    return this.httpClient.patch<T>(url, params);
  }

  public showErrorNotification(error = 'error', description = 'erreur') {
    this._notification.error(error, description);
  }
}
